import _ from 'lodash';
import { makeAnalyticsUrls, makeBackofficeUrls, makeHomepageUrl, makeMarketplaceUrl, makeOpenApiUrls, makePassportUrl, makeWorkspaceUrl, makeLabUrl, makeToolsUrl, } from './apis/service/urls';
import { Symbols } from './symbols';
import { ErrorHandlerService } from './apis/service/ErrorHandlerService';
import { DialogService } from './service/DialogService';
import { CommonService } from './service/CommonService';
import { NavgationService } from './service/NavgationService';
import { AuthService } from './service/AuthService';
import { SystemService } from './service/SystemService';
import { BoHttp } from './service/BoHttpService';
import { BoHelperService } from './service/BoHelperService';
import { CoreBasicHttp } from './service/CoreBasicHttpService';
import { LabHttpService } from './service/LabHttpService';
import { CompanyReportApi } from './apis/service/CompanyReportApi';
import { DataResourceApi } from './apis/service/DataResourceApi';
import { ExportApi } from './apis/service/ExportApi';
import { CompanyApi } from './apis/service/CompanyApi';
import { AccountApi } from './apis/service/AccountApi';
import { CompanyXiaoshouyiApi } from './apis/service/CompanyXiaoshouyiApi';
import { MiscApi } from './apis/service/MiscApi';
import { PackageApi } from './apis/service/PackageApi';
import { ProductApi } from './apis/service/ProductApi';
import { InstitutionApi } from './apis/service/InstitutionApi';
import { MarketplaceApi } from './apis/service/MarketplaceApi';
import { AuditService } from '@/service/navigation-library/AuditService';
import { AgencyService } from '@/service/navigation-library/AgencyService';
import { OperationService } from '@/service/navigation-library/OperationService';
import { AccountService } from './service/AccountService';
import { AccountDefaultService } from '@/service/AccountDefaultService';
import { HistroyApi } from './apis/service/HistoryApi';
import { HistoryListService } from './service/HistoryListService';
import { AccountAddTrialService } from './service/AccountAddTrialService';
import { CompanyQueriesService } from './service/CompanyBase/CompanyQueriesService';
import { CompanyService } from './service/CompanyBase/CompanyService';
import { CompanyAddItemService } from './service/CompanyBase/CompanyAddItemService';
import { CompanyProductListService } from './service/CompanyProductListService';
import { CompanyPrivilegeListService } from './service/CompanyPrivilegeListService';
import { CompanyOrganizationCommonService } from './service/CompanyOrganizationCommonService';
import { CompanyOrganizationService } from './service/CompanyOrganizationService';
import { CompanyEditPrivilegeService } from './service/CompanyEditPrivilegeService';
import { ServiceAccountQueries } from './service/ServiceAccountQueries';
import { PackagesService } from './service/packages/PackagesService';
import { ProductsService } from './service/products/ProductsService';
import { PrivilegeDataService } from './service/PrivilegeDataService';
import { AccountEditService } from './service/AccountEditService';
import { ExportService } from './service/ExportService';
import { OpenapiApi } from './apis/service/OpenapiApi';
import { CompanyReportService } from './service/CompanyReportService';
import { CompanySettingService } from './service/CompanySettingService';
import { HomepageService } from './service/HomepageService';
import { WorkspaceApi } from './apis/service/workspace/WorkspaceApi';
import { WorkspaceHttp } from './service/WorkspaceHttp';
import { DataMigrationService } from './service/workspace/dataMigrationService';
import { HomepageApi } from './apis/service/HomepageApi';
import { TaskCentersService } from './service/workspace/taskCentersService';
import { LabApi } from './apis/service/lab/LabApi';
import { LabService } from './service/lab/LabService';
import { AccountBulkAssignEditService } from './service/AccountBulkAssignEditService';
import { OpenApiHttp } from './service/OpenapiHttpService';
import { CategoryService } from './service/openApi/CategoryService';
import { WhitelistService } from './service/openApi/WhitelistService';
import { ApiService } from './service/openApi/ApiService';
import { PackageService } from './service/openApi/PackageService';
import { TenantKeyService } from './service/openApi/TenantKeyService';
import { PermissionService } from './service/PermissionService';
import { CompanyPermissionApi } from './apis/service/CompanyPermissionApi';
import { ProductService } from './service/ProductService';
import { DashboardHttpService } from './service/DashboardHttpService';
import { DashboardApi } from './apis/service/dashboard/DashboardApi';
import { DashboardService } from './service/dashboard/DashboardService';
import { VeeValidateExtendService } from './service/VeeValidateExtendService';
import { CoreUtilityApi } from './apis/service/coreUtility/CoreUtilityApi';
import { CoreUtilityService } from './service/coreUtility/coreUtilityService';
import { TaskAnalysisService } from './service/workspace/taskAnalysisService';
import { DataAnalysisService } from './service/workspace/dataAnalysisService';
import { CompanyOrderApi } from './apis/service/CompanyOrderApi';
import { CompanyOrderService } from './service/CompanyOrderService';
import { CapacityDetailApi } from './apis/service/CapacityDetailApi';
import { CapacityDetailService } from './service/CapacityDetailService';
import { SystemSamlService } from './service/SystemSamlService';
import { SystemSamlApi } from './apis/service/SystemSamlApi';
import { SystematicApi } from './apis/service/SystematicApi';
import { SystematicService } from './service/SystematicService';
import { SearchEngineManagementApi } from './apis/service/SearchEngineManagementApi';
import { SearchEngineManagementService } from './service/SearchEngineManagementService';
import { MessageSendService } from './service/MessageSendService';
import { MessageSendApi } from './apis/service/MessageSendApi';
import { MailApi } from './apis/service/MailApi';
import { MailService } from './service/MailService';
import { KickoutApi } from './apis/service/KickoutApi';
import { KickoutService } from './service/KickoutService';
import { CacheManagementApi } from './apis/service/coreUtility/CacheManagementApi';
import { CacheManagementService } from './service/coreUtility/CacheManagementService';
import { ApiAnalysisService } from './service/openApi/ApiAnalysisService';
import { ApplyTrialApi } from './apis/service/ApplyTrialApi';
import { ApplyTrialService } from './service/ApplyTrialService';
import { DataProtectionApi } from './apis/service/dataProtection/DataProtectionApi';
import { DataProtectionService } from './service/data-protection/DataProtectionService';
import { DataAnalysisApi } from './apis/service/dataAnalysis/DataAnalysisApi';
import { DataAnalyseService } from './service/data-analysis/DataAnalysisService';
import { DataSeparateService } from './service/workspace/dataSeparateService';
import { BehaviorApi } from './apis/service/BehaviorApi';
import { BehaviorService } from './service/behavior/BehaviorService';
import { AdminApi } from './apis/service/admin/AdminApi';
import { AdminService } from './service/admin/AdminService';
import { ReleasePlanApi } from '@/apis/service/ReleasePlanApi';
import { makeCmsUrl } from './apis/service/urls/cms';
import { CmsApi } from './apis/service/CmsApi';
import { CmsService } from './service/CmsService';
import { SessionManagementApi } from './apis/service/SessionManagementApi';
import { SessionManagementService } from './service/SessionManagementService';
import { ToolApi } from '@/apis/service/ToolApi';
import { ToolHttp } from '@/service/ToolHttpService';
import { SelfRegisterLinkService } from './service/SelfRegisterLinkService';
import { AccountInfoService } from './service/account/AccountInfoService';
import { NoticeCenterApi } from './apis/service/noticeCenter/NoticeCenterApi';
import { NoticeConfigurationService } from './service/noticeCenter/NoticeConfigurationService';
import { IllegalManagementApi } from './apis/service/IllegalManagementApi';
import { IllegalManagementService } from './service/IllegalManagementService';
import { OperationCenterApi } from './apis/service/operation-center/OperationCenterApi';
import { ProductResourceSpaceService } from './service/operation-center/ProductResourceSpaceService';
import { ProductResourceSpaceContentDetailService } from './service/operation-center/ProductResourceSpaceContentDetailService';
import { CommonOptionsService } from './service/CommonOptionsService';
import { CompanyInfoService } from './service/CompanyBase/CompanyInfoService';
import { GlobalViewApi } from './apis/service/GlobalViewApi';
import { GlobalViewService } from './service/globalViewService';
import { CustomerService } from './service/customer/CustomerService';
import { CompanyUserDataAnalysisService } from './service/CompanyBase/CompanyDataAnalysis/CompanyUserDataAnalysisService';
import { CompanyAnalyticsDataAnalysisService } from './service/CompanyBase/CompanyDataAnalysis/CompanyAnalyticsDataAnalysisService';
import { CompanyCopilotDataAnalysisService } from './service/CompanyBase/CompanyDataAnalysis/CompanyCopilotDataAnalysisService';
import { CompanyEurekaDataAnalysisService } from './service/CompanyBase/CompanyDataAnalysis/CompanyEurekaDataAnalysisService';
import { CompanyEurekaAIRDataAnalysisService } from './service/CompanyBase/CompanyDataAnalysis/CompanyEurekaAIRDataAnalysisService';
import { CompanyWorkspaceDataAnalysisService } from './service/CompanyBase/CompanyDataAnalysis/CompanyWorkspaceDataAnalysisService';
import { CompanyBioDataAnalysisService } from './service/CompanyBase/CompanyDataAnalysis/CompanyBioDataAnalysisService';
import { CompanyChemicalDataAnalysisService } from './service/CompanyBase/CompanyDataAnalysis/CompanyChemicalDataAnalysisService';
import { CompanySynapseDataAnalysisService } from './service/CompanyBase/CompanyDataAnalysis/CompanySynapseDataAnalysisService';
import { CompanyConnectDataAnalysisService } from './service/CompanyBase/CompanyDataAnalysis/CompanyConnectDataAnalysisService';
import { CompanyDataAnalysisApi } from './apis/service/company/CompanyDataAnalysisApi';
import { CompanyConnectApi } from './apis/service/company/CompanyConnectApi';
import { CompanyDataAnalysisService } from './service/CompanyBase/CompanyDataAnalysis/CompanyDataAnalysisService';
import { PromptManagementService } from './service/prompt-management/PromptManagementService';
import { PromptManagementApi } from './apis/service/prompt-management/PromptManagementApi';
import { PqlRuleManagementService } from './service/PqlRuleManagementService';
import { PqlRuleManagementApi } from './apis/service/PqlRuleManagementApi';
import { ProductLineService } from './service/operation-center/ProductLineService';
import { EmailTemplateManagementService } from './service/email-template-management/EmailTemplateManagementService';
import { Image2CodeService } from './service/email-template-management/Image2CodeService';
import { EmailTemplateManagementApi } from './apis/service/email-template-management/EmailTemplateManagementApi';
import { CopyService } from './service/CopyService';
import { CompanyInsightsService } from './service/CompanyBase/company-insights-service';
import { SamlCertificateService } from './service/SamlCertificateService';
import { AccountDataAnalysisApi } from './apis/service/account/AccountDataAnalysisApi';
import { AccountDataAnalysisService } from './service/account/AccountDataAnalysisService';
import { AccountEurekaDataAnalysisService } from './service/account/AccountEurekaDataAnalysisService';
export function buildService(container, params) {
    const { uniSetting, vue, i18n, router, httpClient, passportUrlBase, backofficeUrlBase, labUrlBase, environment, psAxios, } = params;
    // Common
    container.bind(Symbols.Environment)
        .toConstantValue(environment);
    container.bind(Symbols.UniSetting)
        .toConstantValue(uniSetting);
    container
        .bind(Symbols.Vue)
        .toConstantValue(vue);
    container
        .bind(Symbols.I18n)
        .toConstantValue(i18n);
    container
        .bind(Symbols.Router)
        .toConstantValue(router);
    container
        .bind(Symbols.HttpClient)
        .toConstantValue(httpClient);
    container
        .bind(Symbols.PsAxios)
        .toConstantValue(psAxios);
    container
        .bind(Symbols.ErrorHandlerService)
        .to(ErrorHandlerService);
    container
        .bind(Symbols.SystemService)
        .to(SystemService);
    container
        .bind(Symbols.DialogService)
        .to(DialogService);
    container
        .bind(Symbols.CopyService)
        .to(CopyService);
    container
        .bind(Symbols.BoHttp)
        .to(BoHttp);
    container
        .bind(Symbols.BoHelperService)
        .to(BoHelperService);
    container.bind(Symbols.OpenApiHttp)
        .to(OpenApiHttp);
    container
        .bind(Symbols.WorkspaceHttp)
        .to(WorkspaceHttp);
    container
        .bind(Symbols.CoreBasicHttp)
        .to(CoreBasicHttp);
    container
        .bind(Symbols.LabHttp)
        .to(LabHttpService);
    container
        .bind(Symbols.DashboardHttp)
        .to(DashboardHttpService);
    container
        .bind(Symbols.ToolHttp)
        .to(ToolHttp);
    container.bind(Symbols.NavgationService)
        .to(NavgationService);
    const backofficeUrls = makeBackofficeUrls(backofficeUrlBase);
    const passportUrls = makePassportUrl(passportUrlBase);
    const marketplaceUrls = makeMarketplaceUrl(backofficeUrlBase);
    const workspaceUrls = makeWorkspaceUrl(backofficeUrlBase);
    const analyticsUrls = makeAnalyticsUrls(backofficeUrlBase);
    const openApiUrls = makeOpenApiUrls(backofficeUrlBase);
    const homepageUrls = makeHomepageUrl(backofficeUrlBase);
    const labUrls = makeLabUrl(labUrlBase);
    const cmsUrls = makeCmsUrl(backofficeUrlBase);
    const toolUrls = makeToolsUrl(backofficeUrlBase);
    container.bind(Symbols.AnalyticsCoreSearhUrls)
        .toConstantValue(analyticsUrls.coreSearch);
    container.bind(Symbols.AnalyticsPromptUrls)
        .toConstantValue(analyticsUrls.prompt);
    container.bind(Symbols.AnalyticsEmailTemplateUrls)
        .toConstantValue(analyticsUrls.emailTemplate);
    container.bind(Symbols.SystemUrls)
        .toConstantValue(backofficeUrls.system);
    container.bind(Symbols.PassportSamlUrls)
        .toConstantValue(passportUrls.saml);
    container.bind(Symbols.PassportOauthUrls)
        .toConstantValue(passportUrls.oauth);
    // 服务配置
    const serviceDeclares = [
        {
            id: Symbols.AuthService,
            cls: AuthService,
        },
        {
            id: Symbols.AccountService,
            cls: AccountService,
        },
        {
            id: Symbols.AccountDefaultService,
            cls: AccountDefaultService,
        },
        {
            id: Symbols.AccountInfoService,
            cls: AccountInfoService,
        },
        {
            id: Symbols.ServiceAccountQueries,
            cls: ServiceAccountQueries,
        },
        {
            id: Symbols.PackagesService,
            cls: PackagesService,
        },
        {
            id: Symbols.ProductsService,
            cls: ProductsService,
        },
        {
            id: Symbols.AccountEditService,
            cls: AccountEditService,
        },
        {
            id: Symbols.PrivilegeDataService,
            cls: PrivilegeDataService,
        },
        {
            id: Symbols.ExportService,
            cls: ExportService,
        },
        {
            id: Symbols.CommonService,
            cls: CommonService,
        },
        {
            id: Symbols.CommonOptionsService,
            cls: CommonOptionsService,
        },
        {
            id: Symbols.HistoryListService,
            cls: HistoryListService,
        },
        {
            id: Symbols.AccountAddTrialService,
            cls: AccountAddTrialService,
        },
        {
            id: Symbols.CompanyQueriesService,
            cls: CompanyQueriesService,
        },
        {
            id: Symbols.CompanyService,
            cls: CompanyService,
        },
        {
            id: Symbols.CompanyInfoService,
            cls: CompanyInfoService,
        },
        {
            id: Symbols.CompanyAddItemService,
            cls: CompanyAddItemService,
        },
        {
            id: Symbols.CompanySettingService,
            cls: CompanySettingService,
        },
        {
            id: Symbols.CompanyReportService,
            cls: CompanyReportService,
        },
        {
            id: Symbols.CompanyProductListService,
            cls: CompanyProductListService,
        },
        {
            id: Symbols.CompanyDataAnalysisService,
            cls: CompanyDataAnalysisService,
        },
        {
            id: Symbols.CompanyUserDataAnalysisService,
            cls: CompanyUserDataAnalysisService,
        },
        {
            id: Symbols.CompanyAnalyticsDataAnalysisService,
            cls: CompanyAnalyticsDataAnalysisService,
        },
        {
            id: Symbols.CompanyCopilotDataAnalysisService,
            cls: CompanyCopilotDataAnalysisService,
        },
        {
            id: Symbols.CompanyEurekaDataAnalysisService,
            cls: CompanyEurekaDataAnalysisService,
        },
        {
            id: Symbols.CompanyEurekaAIRDataAnalysisService,
            cls: CompanyEurekaAIRDataAnalysisService,
        },
        {
            id: Symbols.CompanyWorkspaceDataAnalysisService,
            cls: CompanyWorkspaceDataAnalysisService,
        },
        {
            id: Symbols.CompanyBioDataAnalysisService,
            cls: CompanyBioDataAnalysisService,
        },
        {
            id: Symbols.CompanySynapseDataAnalysisService,
            cls: CompanySynapseDataAnalysisService,
        },
        {
            id: Symbols.CompanyChemicalDataAnalysisService,
            cls: CompanyChemicalDataAnalysisService,
        },
        {
            id: Symbols.CompanyConnectDataAnalysisService,
            cls: CompanyConnectDataAnalysisService,
        },
        {
            id: Symbols.CompanyInsightsService,
            cls: CompanyInsightsService,
        },
        {
            id: Symbols.SamlCertificateService,
            cls: SamlCertificateService,
        },
        {
            id: Symbols.AccountDataAnalysisService,
            cls: AccountDataAnalysisService,
        },
        {
            id: Symbols.AccountEurekaDataAnalysisService,
            cls: AccountEurekaDataAnalysisService,
        },
        {
            id: Symbols.HomepageService,
            cls: HomepageService,
        },
        {
            id: Symbols.CompanyPrivilegeListService,
            cls: CompanyPrivilegeListService,
        },
        {
            id: Symbols.CompanyOrganizationCommonService,
            cls: CompanyOrganizationCommonService,
        },
        {
            id: Symbols.CompanyOrganizationService,
            cls: CompanyOrganizationService,
        },
        {
            id: Symbols.CompanyEditPrivilegeService,
            cls: CompanyEditPrivilegeService,
        },
        {
            id: Symbols.AccountBulkAssignEditService,
            cls: AccountBulkAssignEditService,
        },
        {
            id: Symbols.ProductService,
            cls: ProductService,
        },
        {
            id: Symbols.SystemSamlService,
            cls: SystemSamlService,
        },
        {
            id: Symbols.SystemSamlApi,
            cls: SystemSamlApi,
            urlsId: Symbols.SystemSamlApiUrls,
            urls: backofficeUrls.systemSaml,
        },
        {
            id: Symbols.SearchEngineManagementService,
            cls: SearchEngineManagementService,
        },
        {
            id: Symbols.SearchEngineManagementApi,
            cls: SearchEngineManagementApi,
            urlsId: Symbols.SearchEngineManagementApiUrls,
            urls: backofficeUrls.searchEngineManagement,
        },
        {
            id: Symbols.KickoutApi,
            cls: KickoutApi,
            urls: Symbols.KickoutService,
        },
        {
            id: Symbols.KickoutService,
            cls: KickoutService,
        },
        {
            id: Symbols.MessageSendService,
            cls: MessageSendService,
        },
        {
            id: Symbols.MessageSendApi,
            cls: MessageSendApi,
            urlsId: Symbols.MessageSendApiUrls,
            urls: backofficeUrls.messageSend,
        },
        {
            id: Symbols.NoticeCenterApi,
            cls: NoticeCenterApi,
            urlsId: Symbols.NoticeCenterUrls,
            urls: backofficeUrls.noticeCenter,
        },
        {
            id: Symbols.NoticeConfigurationService,
            cls: NoticeConfigurationService,
        },
        {
            id: Symbols.MailService,
            cls: MailService,
        },
        {
            id: Symbols.MailApi,
            cls: MailApi,
            urlsId: Symbols.MailApiUrls,
            urls: backofficeUrls.mail,
        },
        {
            id: Symbols.CacheManagementService,
            cls: CacheManagementService,
        },
        {
            id: Symbols.CacheManagementApi,
            cls: CacheManagementApi,
            urlsId: Symbols.CacheManagementUrls,
            urls: backofficeUrls.cacheManagement,
        },
        // #region BoService
        {
            id: Symbols.AccountApi,
            cls: AccountApi,
            urlsId: Symbols.AccountApiUrls,
            urls: backofficeUrls.account,
        },
        {
            id: Symbols.DataResourceApi,
            cls: DataResourceApi,
            urlsId: Symbols.DataResourceApiUrls,
            urls: backofficeUrls.dataResources,
        }, {
            id: Symbols.CompanyReportApi,
            cls: CompanyReportApi,
            urlsId: Symbols.CompanyReportApiUrls,
            urls: backofficeUrls.companyReport,
        }, {
            id: Symbols.ExportApi,
            cls: ExportApi,
            urlsId: Symbols.ExportApiUrls,
            urls: backofficeUrls.export,
        }, {
            id: Symbols.CompanyApi,
            cls: CompanyApi,
            urlsId: Symbols.CompanyApiUrls,
            urls: backofficeUrls.company,
        }, {
            id: Symbols.CompanyXiaoshouyiApi,
            cls: CompanyXiaoshouyiApi,
            urlsId: Symbols.CompanyXiaoshouyiApiUrls,
            urls: backofficeUrls.companyXiaoshouyi,
        }, {
            id: Symbols.CompanyDataAnalysisApi,
            cls: CompanyDataAnalysisApi,
            urlsId: Symbols.CompanyDataAnalysisUrls,
            urls: backofficeUrls.companyDataAnalysis,
        }, {
            id: Symbols.CompanyConnectApi,
            cls: CompanyConnectApi,
            urlsId: Symbols.CompanyConnectUrls,
            urls: backofficeUrls.companyConnect,
        },
        {
            id: Symbols.AccountDataAnalysisApi,
            cls: AccountDataAnalysisApi,
            urlsId: Symbols.AccountDataAnalysisUrls,
            urls: backofficeUrls.accountDataAnalysis,
        },
        {
            id: Symbols.MiscApi,
            cls: MiscApi,
            urlsId: Symbols.MiscApiUrls,
            urls: backofficeUrls.misc,
        },
        {
            id: Symbols.PackageApi,
            cls: PackageApi,
            urlsId: Symbols.PackageApiUrls,
            urls: backofficeUrls.package,
        },
        {
            id: Symbols.ProductApi,
            cls: ProductApi,
            urlsId: Symbols.ProductApiUrls,
            urls: backofficeUrls.product,
        },
        {
            id: Symbols.HistoryApi,
            cls: HistroyApi,
            urlsId: Symbols.HistoryApiUrls,
            urls: backofficeUrls.history,
        },
        {
            id: Symbols.SystematicApi,
            cls: SystematicApi,
        },
        {
            id: Symbols.SystematicService,
            cls: SystematicService,
        },
        // #endregion
        // #region
        {
            id: Symbols.CompanyOrderApi,
            cls: CompanyOrderApi,
            urlsId: Symbols.CompanyOrderApiUrls,
            urls: backofficeUrls.companyOrder,
        },
        {
            id: Symbols.CompanyOrderService,
            cls: CompanyOrderService,
        },
        // #endregion
        // #region Passport
        {
            id: Symbols.InstitutionApi,
            cls: InstitutionApi,
            urlsId: Symbols.PassportPublicUrls,
            urls: passportUrls.public,
        },
        // #endregion
        // #region Marketplace
        {
            id: Symbols.MarketplaceApi,
            cls: MarketplaceApi,
            urlsId: Symbols.MarketplaceApiUrls,
            urls: marketplaceUrls.marketplace,
        },
        {
            id: Symbols.AuditService,
            cls: AuditService,
        },
        {
            id: Symbols.AgencyService,
            cls: AgencyService,
        },
        {
            id: Symbols.OperationService,
            cls: OperationService,
        },
        // #endregion
        // #region OpenApi
        {
            id: Symbols.OpenApi,
            cls: OpenapiApi,
            urlsId: Symbols.OpenApiUrls,
            urls: openApiUrls,
        },
        {
            id: Symbols.OpenApiCategoryService,
            cls: CategoryService,
        },
        {
            id: Symbols.OpenApiWhitelistService,
            cls: WhitelistService,
        },
        {
            id: Symbols.OpenApiApiService,
            cls: ApiService,
        },
        {
            id: Symbols.OpenApiPackageService,
            cls: PackageService,
        },
        {
            id: Symbols.OpenApiTenantService,
            cls: TenantKeyService,
        },
        {
            id: Symbols.OpenApiApiAnalysisService,
            cls: ApiAnalysisService,
        },
        // #endregion
        // #region workspace
        {
            id: Symbols.WorkspaceApi,
            cls: WorkspaceApi,
            urlsId: Symbols.WorkspaceApiUrls,
            urls: workspaceUrls.workspace,
        },
        {
            id: Symbols.TaskCentersService,
            cls: TaskCentersService,
        },
        {
            id: Symbols.TaskAnalysisService,
            cls: TaskAnalysisService,
        },
        {
            id: Symbols.DataMigrationService,
            cls: DataMigrationService,
        },
        {
            id: Symbols.DataAnalysisService,
            cls: DataAnalysisService,
        },
        {
            id: Symbols.DataSeparateService,
            cls: DataSeparateService,
        },
        // #endregion
        // #region lab
        {
            id: Symbols.LabApi,
            cls: LabApi,
            urlsId: Symbols.LabApiUrls,
            urls: labUrls.lab,
        },
        {
            id: Symbols.LabService,
            cls: LabService,
        },
        // #endregion
        // #region homepage
        {
            id: Symbols.HomepageApi,
            cls: HomepageApi,
            urlsId: Symbols.HomepageApiUrls,
            urls: homepageUrls.homepage,
        },
        {
            id: Symbols.CompanyPermissionApi,
            cls: CompanyPermissionApi,
            urlsId: Symbols.CompanyPermissionApiUrls,
            urls: backofficeUrls.resource,
        },
        {
            id: Symbols.PermissionService,
            cls: PermissionService,
        },
        // #region CapacityDetail
        {
            id: Symbols.CapacityDetailApi,
            cls: CapacityDetailApi,
            urlsId: Symbols.CapacityDetailApiUrls,
            urls: backofficeUrls.capacityDetail,
        },
        {
            id: Symbols.CapacityDetailService,
            cls: CapacityDetailService,
        },
        // #endregion
        // #region dashboard
        {
            id: Symbols.DashboardApi,
            cls: DashboardApi,
        },
        {
            id: Symbols.DashboardService,
            cls: DashboardService,
        },
        // #endregion
        {
            id: Symbols.VeeValidateExtendService,
            cls: VeeValidateExtendService,
        },
        // #region Core Utility
        {
            id: Symbols.CoreUtilityApi,
            cls: CoreUtilityApi,
        },
        {
            id: Symbols.CoreUtilityService,
            cls: CoreUtilityService,
        },
        // #endregion
        // #region Export Management
        {
            id: Symbols.DataProtectionApi,
            cls: DataProtectionApi,
        },
        {
            id: Symbols.DataProtectionService,
            cls: DataProtectionService,
        },
        // #endregion
        // #region ApplyTrial
        {
            id: Symbols.ApplyTrialApi,
            cls: ApplyTrialApi,
            urlsId: Symbols.ApplyTrialUrls,
            urls: backofficeUrls.ApplyTrial,
        },
        {
            id: Symbols.ApplyTrialService,
            cls: ApplyTrialService,
        },
        // #region
        // #region Data Analysis
        {
            id: Symbols.DataAnalysisApi,
            cls: DataAnalysisApi,
        },
        {
            id: Symbols.DataAnalyseService,
            cls: DataAnalyseService,
        },
        // #endregion
        {
            id: Symbols.BehaviorApi,
            cls: BehaviorApi,
            urlsId: Symbols.BehaviorUrls,
            urls: backofficeUrls.Behavior,
        },
        {
            id: Symbols.BehaviorService,
            cls: BehaviorService,
        },
        {
            id: Symbols.AdminApi,
            cls: AdminApi,
            urlsId: Symbols.IAdminUrls,
            urls: backofficeUrls.admin,
        },
        {
            id: Symbols.AdminService,
            cls: AdminService,
        },
        {
            id: Symbols.ReleasePlanApi,
            cls: ReleasePlanApi,
            urlsId: Symbols.ReleasePlanUrls,
            urls: backofficeUrls.ReleasePlain,
        },
        {
            id: Symbols.CmsApi,
            cls: CmsApi,
            urlsId: Symbols.CmsUrls,
            urls: cmsUrls,
        },
        {
            id: Symbols.CmsService,
            cls: CmsService,
        },
        {
            id: Symbols.SessionManagementApi,
            cls: SessionManagementApi,
            urlsId: Symbols.SessionManagementUrls,
            urls: backofficeUrls.SessionManagement,
        },
        {
            id: Symbols.SessionManagementService,
            cls: SessionManagementService,
        },
        // {
        //     id: Symbols.BehaviorApi,
        //     cls: BehaviorApi,
        //     urlsId: Symbols.BehaviorUrls,
        //     urls: backofficeUrls.Behavior,
        // },
        {
            id: Symbols.ToolApi,
            cls: ToolApi,
            urlsId: Symbols.ToolUrls,
            urls: toolUrls,
        },
        {
            id: Symbols.SelfRegisterLinkService,
            cls: SelfRegisterLinkService,
        },
        {
            id: Symbols.IllegalManagementApi,
            cls: IllegalManagementApi,
            urlsId: Symbols.IllegalManagementUrls,
            urls: backofficeUrls.IllegalManagement,
        },
        {
            id: Symbols.IllegalManagementService,
            cls: IllegalManagementService,
        },
        {
            id: Symbols.OperationCenterApi,
            cls: OperationCenterApi,
            urlsId: Symbols.OperationCenterUrls,
            urls: backofficeUrls.OperationCenter,
        },
        {
            id: Symbols.ProductResourceSpaceService,
            cls: ProductResourceSpaceService,
        },
        {
            id: Symbols.ProductLineService,
            cls: ProductLineService,
        },
        {
            id: Symbols.ProductResourceSpaceContentDetailService,
            cls: ProductResourceSpaceContentDetailService,
        },
        {
            id: Symbols.GlobalViewApi,
            cls: GlobalViewApi,
            urlsId: Symbols.GlobalViewUrls,
            urls: backofficeUrls.GlobalView,
        },
        {
            id: Symbols.GlobalViewService,
            cls: GlobalViewService,
        },
        {
            id: Symbols.CustomerService,
            cls: CustomerService,
        },
        {
            id: Symbols.PromptManagementApi,
            cls: PromptManagementApi,
            urlsId: Symbols.PromptManagementUrls,
            urls: backofficeUrls.PromptManagement,
        },
        {
            id: Symbols.PromptManagementService,
            cls: PromptManagementService,
        },
        {
            id: Symbols.PqlRuleManagementService,
            cls: PqlRuleManagementService,
        },
        {
            id: Symbols.PqlRuleManagementApi,
            cls: PqlRuleManagementApi,
            urlsId: Symbols.PqlRuleManagementUrls,
            urls: backofficeUrls.PqlRuleManagement,
        },
        {
            id: Symbols.EmailTemplateManagementApi,
            cls: EmailTemplateManagementApi,
            urlsId: Symbols.EmailTemplateManagementUrls,
            urls: backofficeUrls.EmailTemplateManagement,
        },
        {
            id: Symbols.EmailTemplateManagementService,
            cls: EmailTemplateManagementService,
        },
        {
            id: Symbols.Image2CodeService,
            cls: Image2CodeService,
        }
    ];
    _.each(serviceDeclares, declare => {
        const { id, cls, urlsId, urls, } = declare;
        container.bind(id).to(cls);
        if (urlsId && urls) {
            container.bind(urlsId).toConstantValue(urls);
        }
    });
}
export { Symbols, };
